module.exports = __webpack_public_path__ + "img/85.7b26ba41.jpg";